(ns teamoesterreich.util.geo-helper
  (:require [clojure.string]
            [teamoesterreich.util.log :as log]
            ))



(def googleGeoCoder (js/google.maps.Geocoder.))

(defn addressComponents-parse [comp]
  (let [struct (reduce
                 (fn [c ^js e]
                   (log/out e)
                   (merge c
                          (case (first (get-in e ["types"]))
                            "postal_code" [:zip (get e "long_name")]
                            "locality" [:city (get e "long_name")]
                            "street_number" [:streetNo (get e "long_name")]
                            "route" [:street (get e "long_name")]
                            {:lng (.lng (.-location (.-geometry e)))
                             :lat (.lat (.-location (.-geometry e)))
                             }
                            ))

                   ) {} (js->clj comp))]
    (assoc struct :address (str (:zip struct) " " (:city struct) " " (:street struct) " " (:streetNo struct)))
    ))


(defn geo-revers-lookup [lat lng cb-fn]
  (log/out "geo-revers-lookup" lat lng googleGeoCoder)
  (.geocode googleGeoCoder
            #js {:location (js/google.maps.LatLng. lat lng)}
            (fn [result status]
              ;(log/out "geo-revers-lookup " (first (js->clj result)) status )
              (when (= status "OK")
                (cb-fn (addressComponents-parse (get (first (js->clj result)) "address_components")))
                ))))


(defn geo-lookup [address cb-fn]
  (log/out "geo-lookup" address googleGeoCoder)
  (.geocode googleGeoCoder
            #js {:address               address
                 :componentRestrictions #js {:country "at"}}
            (fn [result status]
              ;(log/out "geo-lookup " (first (js->clj result)) status )
              (when (= status "OK")
                (cb-fn (addressComponents-parse (get (first (js->clj result)) "address_components")))
                ))))



